<template>
    <div>
        <el-header class="header" height="80px">
            <Header class="animate__animated animate__fadeInDown" :websiteData="websiteData" :menuShow="false"/>
        </el-header>

        <div style="overflow-x: hidden;">
            <div class="bannerheight bannerbg"
                 style="background-image: url('http://free.demo.demososo.com/DM-static/upload/image/common/20190718_180006_8297.jpg');">
                <div class="dmbanneroverlay"></div>
                <div class="title-text animate__animated animate__fadeInUp">
                    <p style="color: #fff;font-size: 40px;font-weight: 500;">
                        {{contentData.classifyTitle}}详情
                    </p>
                </div>
            </div>
            <div class="margin">
                <div style="display: flex;justify-content: space-between;padding: 0 20px;align-items: center">
                    <div style="font-weight: bold">
                        {{contentData.classifyTitle}}详情
                    </div>
                    <div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>{{contentData.classifyTitle}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{contentData.classifyTitle}}详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>

                <el-divider></el-divider>

                <el-row>
                    <el-col style="display: flex;flex-direction: column;align-items: center;padding: 0 20px;" :xs="24"
                            :sm="24" :md="24" :lg="24" :xl="24">
                        <div class="dmcontent">
                            {{contentData.title}}
                        </div>
                        <div style="padding: 20px 0;text-align: center;color: #999;">
                            发布日期：{{contentData.time}}
                        </div>
                        <el-row>
                            <el-col
                                    :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                <div style="display: flex;justify-content: center;align-items: center;">
                                    <el-image style="margin-top: 20px;width: 100%;height: 100%;" lazy
                                              :preview-src-list="[contentData.url]"
                                              v-if="contentData.url"
                                              :src='contentData.url'>
                                        <div slot="error" class="image-slot"
                                             style="display: flex;justify-content: center;align-items: center;height: 100%;">
                                            <i style="font-size: 40px" class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                            </el-col>
                            <el-col style="padding: 0 20px;"
                                    :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                <div>
                                    <p class="ql-editor" style="color: #333;font-size: 14px;padding: 0;" v-html="contentData.content"></p>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <el-footer style="background: #0094ff;height: 100%;padding: 20px 0;overflow-x: hidden">
            <Footer :websiteData="websiteData"/>
        </el-footer>
    </div>

</template>

<script>
    import Header from "@/components/header/index"
    import Footer from "@/components/footer/index"
    import {getContentInfo} from "@/api/content"


    export default {
        name: "news-index",
        components: {
            Header,
            Footer
        },
        data() {
            return {
                activeName: '1',
                contentData: {},
                websiteData: {},
            }
        },
        created() {
            let contentId = this.$route.query.contentId
            if (contentId) {
                getContentInfo(contentId).then(response => {
                    this.contentData = response.data
                })
            } else {
                this.$message.error('contentId为空');
                return
            }

            let data = sessionStorage.getItem('websiteData')
            if (data) {
                this.websiteData = JSON.parse(data)
            }
        },
    }
</script>

<style lang="scss">
    .dmcontent {
        font-weight: bold;
        font-size: 24px;
        line-height: 40px;
        padding: 20px 0px;
        text-align: center;
    }

    .header {
        display: flex;
        align-items: center;
        padding: 0;
    }

    .el-divider--horizontal {
        margin: 10px 0;
    }

    .bannerheight {
        height: 280px;
        background-color: #74BBF1;
        color: #fff;
        z-index: -1;
    }

    .bannerbg {
        position: relative;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .dmbanneroverlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(32, 32, 32, 0.49);
        z-index: -1;
    }

    .title-text {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }


    .margin {
        width: 1200px;
        margin: 20px auto;
    }

    @media screen and (min-width: 1200px) {
        .dmcontent {
            width: 100%;
        }

    }

    @media screen and (max-width: 1200px) {

        .dmcontent {
            width: 100%;
        }

    }

    @media screen and (max-width: 870px) {
        .margin {
            width: 100%;
        }

        .dmcontent {
            width: 100%;
            font-size: 20px;
        }

    }

    @media screen and (max-width: 570px) {
        .margin {
            width: 100%;
        }

        .dmcontent {
            width: 100%;
            font-size: 20px;
        }

    }
</style>
